export default __webpack_public_path__ + "static/media/x-circle.1851eeaa.svg";